<template>
  <div class="mob-remove-table-fixed node-list">
    <Drawer v-model="logsDrawer" width="600">
      <OperateLogs ref="OperateLogs" :logs="logs"></OperateLogs>
    </Drawer>
    <Card shadow>
      <Row class="sm-pc-w100">
        <Col :md="22">
          <Form :model="tableSearchForm" ref="tableSearchForm" inline :label-width="40" @submit.native.prevent>
            <FormItem label="名称">
              <Input v-model="tableSearchForm.name" style="min-width: 200px" />
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getTableData()">搜索</Button>
              <Button style="margin-left: 8px" @click="clearSearchForm">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="2" class="align-right">
          <Button
            style="float: right;"
            @click="$router.push({name: 'container_node_add'})"
            type="primary"
            :style="{marginBottom: '10px'}"
            icon="md-add">添加节点</Button>
        </Col>
      </Row>
      <Alert v-if="listError" type="warning" show-icon>获取数据失败</Alert>
      <Table
        v-else
        border
        highlight-row
        :loading="tableLoading"
        ref="table"
        :data="table.data"
        :columns="table.columns"></Table>
      <div style="margin: 10px 0; overflow: hidden;">
        <div style="float: left;">
          当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
        </div>
        <div style="float: right;">
          <page
            :total="table.count"
            :current="table.page"
            :page-size="table.size"
            @on-change="getTableData"></page>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getNodes, deleteNode } from '@/api/container/node'
import OperateLogs from '../components/operateLogs'
import moment from 'moment'

export default {
  name: 'list',
  components: {
    OperateLogs
  },
  data () {
    return {
      tableLoading: false,
      tableSearchForm: {
        name: ''
      },
      table: {
        data: [],
        columns: [
          {
            title: '名称',
            key: 'name',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: 'URL',
            key: 'url',
            align: 'center',
            tooltip: true,
            minWidth: 170
          },
          {
            title: '开启tls',
            key: 'is_tls',
            align: 'center',
            tooltip: true,
            minWidth: 80,
            render: (h, params) => {
              return h('span', params.row.is_tls ? '是' : '否')
            }
          },
          {
            title: '创建用户',
            key: 'created_user',
            align: 'center',
            tooltip: true,
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.created_user.name ? params.row.created_user.name : params.row.created_user.username)
            }
          },
          {
            title: '创建时间',
            key: 'created_at',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.created_at) {
                return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '最后修改用户',
            key: 'updated_user',
            align: 'center',
            tooltip: true,
            minWidth: 110,
            render: (h, params) => {
              return h('span', params.row.updated_user.name ? params.row.updated_user.name : params.row.updated_user.username)
            }
          },
          {
            title: '最后修改时间',
            key: 'updated_at',
            align: 'center',
            tooltip: true,
            minWidth: 150,
            render: (h, params) => {
              if (params.row.updated_at) {
                return h('span', moment(params.row.updated_at).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '操作',
            align: 'center',
            fixed: 'right',
            width: 170,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.logs = params.row.logs
                      this.logsDrawer = true
                    }
                  }
                }, '日志'),
                h('Button', {
                  props: {
                    type: 'warning',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$router.push({name: 'container_node_edit', params: {id: params.row.id}})
                    }
                  }
                }, '编辑'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    transfer: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.delete(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                    }
                  }, '删除')
                ])
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      listError: false,
      moment: moment,
      logsDrawer: false,
      logs: []
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    getTableData (value = 1) {
      this.table.page = value
      this.tableLoading = true
      this.tableSearchForm['size'] = this.table.size
      this.tableSearchForm['page'] = this.table.page
      getNodes(this.tableSearchForm).then(res => {
        let result = res.data
        this.table.data = result.results
        this.table.count = result.count
        this.tableLoading = false
        this.listError = false
      }).catch(res => {
        this.tableLoading = false
        console.log(res.response)
        this.listError = true
      })
    },
    clearSearchForm () {
      this.tableSearchForm = {
        name: ''
      }
    },
    delete (id) {
      deleteNode(id).then(res => {
        this.$Notice.success({ title: '操作成功！' })
        this.getTableData(this.table.page)
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '操作失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '操作失败！'
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
